import React from 'react';

function findLinkEntities(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                contentState.getEntity(entityKey).getType() === 'LINK'
            );
        },
        callback
    );
}

const Link = (props) => {
    const data = props.contentState.getEntity(props.entityKey).getData();

    return <span className="decorated-link"><a
        href={data.url}
        title={data.title}
        target={data.target}
        rel={data.rel}
    >
        {props.children}
    </a></span>;
};

export default {
    strategy: findLinkEntities,
    component: Link,
};
